import React from 'react'
import './RadioGroup.scss'

type RadioGroupProps = {
    title: string
    classes?: string[]
    errorClasses?: string[]
    errorMessage?: string
}

const RadioGroup: React.FC<RadioGroupProps> = (props) => {

    const {
        title,
        errorMessage,
        errorClasses,
        classes,
        children,
    } = props

    let wrapClasses = ['radio-group']

    if (classes) wrapClasses = wrapClasses.concat(classes)
    if (errorClasses && errorMessage) wrapClasses = wrapClasses.concat(errorClasses)

    return (
        <div className={wrapClasses.join(' ')}>
            <p className="radio-group__title" id="radio-group-title">{title}</p>
            <ul className={errorMessage ? "radio-group error" : "radio-group"}>
                {
                    children
                }
            </ul>
            {
                errorMessage
                    ? <p className="bf-input-error-message">{errorMessage}</p>
                    : null
            }
        </div>
    )
}

export default RadioGroup